// extracted by mini-css-extract-plugin
var _1 = "togglebutton_active__o-7em";
var _2 = "#4c4c4c";
var _3 = "togglebutton_button__l65fn";
var _4 = "640px";
var _5 = "790px";
var _6 = "#057676";
var _7 = "togglebutton_disablehover__5gj5o";
var _8 = "togglebutton_disabled__yxwgx";
var _9 = "togglebutton_hasloadingtext__yy-ag";
var _a = "#434343";
var _b = "togglebutton_icon__nrfeu";
var _c = "togglebutton_label__zah2p";
var _d = "togglebutton_loading__fg7ad";
var _e = "togglebutton_loadingtext__kpik1";
var _f = "79px";
var _10 = "110px";
var _11 = "72px";
var _12 = "665px";
var _13 = "togglebutton_spinner__-sd6y";
var _14 = "teal";
var _15 = "togglebutton_text__rp2tc";
var _16 = "2";
var _17 = "#cdd3dc";
export { _1 as "active", _2 as "body", _3 as "button", _4 as "controlsMobileWidth", _5 as "controlsStackedWidth", _6 as "darkTeal", _7 as "disableHover", _8 as "disabled", _9 as "hasLoadingText", _a as "headline", _b as "icon", _c as "label", _d as "loading", _e as "loadingText", _f as "menuHeight", _10 as "menuHeightLarge", _11 as "menuHeightMobile", _12 as "modalMobileWidth", _13 as "spinner", _14 as "teal", _15 as "text", _16 as "timelineStrokeWidth", _17 as "timelineTrackColor" }
